import {stringRepeat} from '@dazn/peng-html5-tools-utils';

/**
 * Pads a numeric code with leading zeros for the required length.
 *
 * @param value number to be formatted
 * @param requiredLength required length of the formatted string
 */
const padWithLeadingZeros = (value: number, requiredLength: number): string => {
    const valueString = value.toString();
    const valueLength = valueString.length;

    if (valueLength >= requiredLength) {
        return valueString;
    }

    const leadingZeros = stringRepeat('0', requiredLength - valueLength);

    return `${leadingZeros}${value}`;
};

export {padWithLeadingZeros};
